import { Outlet } from 'react-router-dom'
import { AdminMobileHeader, AdminSidebar } from '@/components/admin/admin-sidebar'

export function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-muted/30">
      <AdminSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <AdminMobileHeader />
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
